<template>
  <el-row
    :gutter="5"
    type="flex"
  >
    <el-col :span="5">
      <el-card
        class="clear-card firstCard"
        shadow="hover"
      >
        <div class="name">
          {{ engagement.coach_info ? engagement.coach_info.name : '' }}
        </div>

        <div class="duration">
          {{ engagement.duration }} {{ $t('session.sessions') }}
        </div>
      </el-card>
    </el-col>

    <el-col :span="5">
      <el-card
        class="clear-card startDateCard"
        shadow="hover"
      >
        <div
          slot="header"
          class="header"
        >
          {{ $t('common.startDate') }}
        </div>

        <div>
          {{ engagement.start_date }}
        </div>
      </el-card>
    </el-col>

    <el-col :span="5">
      <el-card
        class="clear-card endDateCard"
        shadow="hover"
      >
        <div
          slot="header"
          class="header"
        >
          {{ $t('common.endDate') }}
        </div>

        <div>
          {{ engagement.end_date }}
        </div>
      </el-card>
    </el-col>

    <el-col :span="9">
      <el-card
        class="clear-card lgaCard"
        shadow="hover"
      >
        <div
          slot="header"
          class="header"
        >
          {{ $t('lga.myLgaLong') }}
        </div>

        <div class="content">
          <div>
            {{ engagement.lga1 }}
          </div>
          <div>
            {{ engagement.lga2 }}
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'EngagementSummary',

  props: {
    engagement: {
      type: Object,
      default: null,
    },
  },

  data: () => ({ }),
};
</script>

<style lang="scss" scoped>
.el-card {
  height: 100%;
  text-align: center;

  &.firstCard {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;

    .name {
      margin-top: 25px;
      font-weight: bold;
    }

    .duration {
      margin-top: 10px;
      font-style: italic;
    }
  }

  &.startDateCard,
  &.endDateCard {
    border-radius: 0;
    font-weight: bold;
  }

  &.lgaCard {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

    .content {
      font-style: italic;
    }
  }

  .header {
    font-weight: bold;
    text-align: center;
  }
}
</style>
